import React from 'react';
import JsonEditor from './JsonEditor';
import { ConfigType } from 'config/config';
import { JSONEditorMode } from 'jsoneditor';

type JSONEditorWrapperProps = {
  initialJson: JSONType;
  defaultMode?: JSONEditorMode;
  allowedModes?: JSONEditorMode[];
  enableSort?: boolean;
  enableTransform?: boolean;
  setJson: React.Dispatch<React.SetStateAction<ConfigType>>;
};

export type JSONType = { [key: string]: any };

const JSONEditorWrapper = ({
  initialJson,
  defaultMode = 'tree',
  allowedModes = ['tree', 'view', 'code'],
  enableSort = false,
  enableTransform = false,
  setJson,
}: JSONEditorWrapperProps) => {
  return (
    <JsonEditor
      json={initialJson}
      setJson={setJson}
      mode={defaultMode}
      modes={allowedModes}
      enableSort={enableSort}
      enableTransform={enableTransform}
    />
  );
};

export default JSONEditorWrapper;
